var map = {
	"./Commoditylayout.json": "443a",
	"./DisplayBoard.json": "40a0",
	"./GIS.json": "7568",
	"./Intelligentlocation.json": "1c2f",
	"./Intelligentscheduling.json": "6970",
	"./Intelligentsupplementaryadjustment.json": "c6de",
	"./Intelligentvideoanalysis.json": "8d7c",
	"./Inventorysimulation.json": "34d4",
	"./Jingyuanchain.json": "21be",
	"./Monitoringvideonetworking.json": "5420",
	"./Networksimulation.json": "bd0b",
	"./Salesforecast.json": "cda2",
	"./Signatureonthechain.json": "b1ba",
	"./Sitesimulation.json": "3ed3",
	"./WMS.json": "b3c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fbf";